$(function() {
    $(document).on('click', 'input[type=checkbox]', function() {
        var terms_conditions = $('input[name=terms_and_conditions]').prop('checked');
        var contact_permission = $('input[name=contact_permission]').prop('checked');

        if (terms_conditions && contact_permission) {
            $('#rsvp_submit').removeAttr('disabled');
        } else {
            $('#rsvp_submit').attr('disabled', 'disabled');
        }
    });

});
